export default __webpack_public_path__ + "static/media/27.552e59eb.jpeg";